import React from 'react';
import { BarChart, Bar, ResponsiveContainer, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Cell, Label } from 'recharts';
import StackedBarChartTemplate2 from './StackedBarChartTemplate2';

class STACKEDBARCHART extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0
    }
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  render() {
    const { graphData, colors, legendName, xLabel, yLabel, graphHeight, series, barChartConfig,
      allowAddition, generatedActionCodeForAllowAddition, inlineActions, triggerAction, workflow,
      triggerData, companyDetails, rawData } = this.props;
    const barSize = barChartConfig && parseInt(barChartConfig.barSize);
    const barColor = barChartConfig && barChartConfig.barColor;
    const oneColorOnly = barChartConfig && barChartConfig.oneColorOnly;
    const { activeTab } = this.props
    let reportLibraryTemplate = companyDetails && companyDetails.companySettings && companyDetails.companySettings.reportLibraryTemplate ? companyDetails.companySettings.reportLibraryTemplate : "TEMPLATE_ONE"
    reportLibraryTemplate = barChartConfig && barChartConfig.stackedbarReportTemplate ? barChartConfig.stackedbarReportTemplate.value : reportLibraryTemplate
    const { columns } = rawData;
    const stacked = barChartConfig.yAxis ? barChartConfig.yAxis.split(',') : []
    let gData = [];
    graphData && graphData.map(g => {
      let tmp = {};
      for (const key in g.tableData) {
        tmp[key.trim()] = g.tableData[key]
      }
      gData.push(tmp)
    });

    if (reportLibraryTemplate === "TEMPLATE_TWO" || reportLibraryTemplate == 'template2') {
      return <StackedBarChartTemplate2 {...this.props} />
    }

    return (
      <div>
        <div style={{ width: '100%', cursor: 'pointer' }} className='reportMainContainer'>
          <ResponsiveContainer height={graphHeight}>
            <BarChart
              responsive
              data={gData} margin={{ top: 0, right: 10, left: 50, bottom: 20 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey={`${barChartConfig.xAxis}`}>
                <Label value={`${barChartConfig.xAxis}`} offset={0} position="bottom" />
              </XAxis>
              <YAxis label={{ value: barChartConfig.yAxis ? barChartConfig.yAxis : yLabel, angle: -90, position: "inside", offset: -15, dx: 40 }}
                tickFormatter={(value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                tickCount={10}
              />
              <Tooltip formatter={(value) => {
                let v = value;
                if (typeof value == 'number') {
                  if (value.toString().indexOf('.') != -1) {
                    v = value.toFixed(2);
                    v = v.split('.');
                    v[0] = v[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    v = v.join('.');
                  } else {
                    v = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  return v;
                }
                return v;
              }} />
              <Legend verticalAlign="top" height={36} />

              {
                stacked.map((y, i) => {
                  const color = this.getRandomColor();
                  return <Bar dataKey={`${y}`} stackId="a" fill={color} barSize={barSize} radius={2} key={y} />
                })
              }

            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>


    );
  }
}

export default STACKEDBARCHART;